/* eslint-disable react/sort-comp */
/* eslint-disable no-param-reassign */
/* eslint-disable array-callback-return */
/* eslint-disable no-unused-expressions */
import React, { Component, Fragment } from 'react';
import { withRouter, Link } from 'react-router-dom';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import {
  ShoppingFilled,
  CloseOutlined,
  EditOutlined,
  StopOutlined,
  InfoCircleOutlined,
} from '@ant-design/icons';

import { QUANTITY, toISTDate, DEFAULT_CUR_ROUND_OFF } from '@Apis/constants';
import {
  Table, Button, Drawer, Select, Popconfirm, Alert,
  Popover,
} from 'antd';
import dayjs from 'dayjs';
import H3FormInput from '@Uilib/h3FormInput';
import OfferActions from '@Actions/offerActions';
import H3Image from '@Uilib/h3Image';
import imageDefault from '@Images/icons/imageDefault.png';
import SelectOffer from '@Components/Common/SelectOffer';
import SelectTax from '@Components/Admin/Common/SelectTax';
import H3Text from '@Uilib/h3Text';
import TenantSelector from '@Components/Common/Selector/TenantSelector';
import SelectDepartment from '@Components/Common/SelectDepartment';
import QuickAddButton from '@Components/Common/UILib/QuickAddButton';
import PurchaseRequestActions from '@Actions/purchaseRequestActions';
import SellerActions from '@Actions/sellerActions';
import ProductActions from '@Actions/productActions';
import PRVerifyPurchaseOrders from '@Components/Purchase/PurchaseRequests/PRVerifyPurchaseOrders';
import closeIcon from '@Images/icons/icon-close-blue.png';
import Helpers from '@Apis/helpers';
import RecentTransactions from '@Components/Inventory/ManageProducts/ViewProduct/RecentTransactions';
import ProductDescriptions from '../../../Common/ProductDescriptions';
import ProductCategoryLabel from '../../../Common/ProductCategoryLabel';
import HideValue from '../../../Common/RestrictedAccess/HideValue';
import CustomFieldHelpers from '@Helpers/CustomFieldHelpers';
import CFV2Actions from '@Actions/configurations/cfV2Actions';
import { v4 as uuidv4 } from 'uuid';
import CustomFieldV3 from '@Components/Common/CustomFieldV3';
import './style.scss';
import PRZSelect from '../../../Common/UI/PRZSelect';
import { GetDocSequence } from '../../../../modules/documentSequence';
import TaxActions from '@Actions/taxActions';

const { Option } = Select;

/**
 * @param value
 * @param record
 * @param label
 */
class PRSellerSelection extends Component {
  /**
   *
   * @param props
   */
  constructor(props) {
    super(props);
    this.customLineInputChange = this.customLineInputChange.bind(this);
    this.customLineInputChangePO = this.customLineInputChangePO.bind(this);
    this.isDataValidPO = this.isDataValidPO.bind(this);
    this.customInputChangePO = this.customInputChangePO.bind(this);

    this.state = {
      formSubmitted: true,
      products_info: [],
      showErrorMessage: false,
      visibleColumns: {
        PRODUCT: {
          label: 'Product',
          visible: true,
          disabled: true,
        },
        AVAILABLE_STOCK: {
          label: 'Available Stock',
          visible: true,
          disabled: true,
        },
        QUANTITY: {
          label: 'Quantity',
          visible: true,
          disabled: true,
        },
        UNIT_PRICE: {
          label: 'Unit Price',
          visible: true,
          disabled: true,
        },
        TAX: {
          label: 'TAX',
          visible: true,
          disabled: true,
        },
        DISCOUNT: {
          label: 'Discount',
          visible: true,
          disabled: true,
        },
        SALES_ACCOUNT: {
          label: 'Sales Account',
          visible: true,
          disabled: true,
        },
        LINE_TOTAL: {
          label: 'Line Total',
          visible: true,
          disabled: true,
        },
      },
      cfPurchaseOrderLine: [],
      cfPurchaseRequestLine: [],
      cfPurchaseOrdersDoc: [],
      cfPurchaseRequestDoc: [],

    };
  }

  /**
   *
   */

  getColumns() {
    const { user, priceMasking, getProductById } = this.props;
    const { isDataMaskingPolicyEnable, isHideCostPrice, isHideSellingPrice } = priceMasking;
    const { visibleColumns, cfPurchaseRequestLine, formSubmitted, cfPurchaseOrderLine, selectedPurchaseRequest } = this.state;
    const mergedArray = cfPurchaseOrderLine.map((orderLine) => {
      const requestLine = cfPurchaseRequestLine.find((request) => request.cfId === orderLine.cfId);
      return requestLine ? { ...orderLine, ...requestLine } : orderLine;
    });
    const tenantId = selectedPurchaseRequest?.issuer_tenant_id ? selectedPurchaseRequest?.issuer_tenant_id : selectedPurchaseRequest?.tenant_id;
    const { userTenantDepartmentId, tenantDefaultStoreId } = Helpers.getUserTenantDepartmentIds(user, tenantId);
    const updatedVisibleColumns = CustomFieldHelpers.updateVisibleColumns(CustomFieldHelpers.postCfStructure(mergedArray), visibleColumns);
    const columns = [
      {
        title: '',
        render: (text, record) => (
          <H3Image
            src={record?.product_sku_info?.assets?.[0]?.url || imageDefault}
            className="prod-table__image"
            style={{ width: '30px', height: '30px', opacity: record?.product_sku_info?.assets?.[0]?.url ? '1' : '0.1' }} // Adjust the width and height as needed
          />
        ),
        visible: true,
        fixed: 'left',
      },
      {
        title: 'Product',
        width: '300px',
        render: (record) => {
          const { formSubmitted } = this.state;
          const { selectedPurchaseRequest, user, updatePrLineValue } = this.props;
          return (
            <div>
              <div className="pr-selection__product-name">
                {!record?.tenant_product_id
                  ? (
                    <H3FormInput
                      value={record.product_sku_name}
                      type="text"
                      containerClassName={`orgInputContainer ${(formSubmitted && !record.product_sku_name) ? 'pr-selection__input-error' : ''}`}
                      labelClassName="orgFormLabel"
                      inputClassName="orgFormInput"
                      onChange={(e) => this.updatePrLineValue(e.target.value, record, 'product_sku_name')}
                      required
                      isTextarea
                    />
                  ) : (
                    <div style={{ display: 'flex', flexDirection: 'column' }}>
                      <div>
                        {record?.product_sku_name}
                      </div>
                      <div className="flex-align-center-justify-between" style={{ gap: '10px' }}>
                        {record?.productCategoryInfo?.category_path?.length > 0 && (
                          <ProductCategoryLabel
                            categoryPath={record?.productCategoryInfo?.category_path}
                            categoryName={record?.productCategoryInfo?.category_path?.at(
                              -1,
                            )}
                            containerStyle={{
                              width: 'fit-content',
                            }}
                          />
                        )}
                        {Helpers.getPermission(Helpers.permissionEntities.PURCHASE_ORDER, Helpers.permissionTypes.CREATE, user) && (
                          <RecentTransactions
                            tenantId={record?.tenantId}
                            productSkuId={record?.product_sku_info?.product_sku_id}
                            internalSkuCode={record?.product_sku_info?.internal_sku_code}
                            refProductCode={record?.product_sku_info?.ref_product_code}
                            productSkuName={record?.product_sku_name}
                          />
                        )}
                      </div>
                    </div>
                  )}
              </div>
              <div className="ant-row">
                {!record?.tenant_product_id && <H3Text text="New Product" className="pr-selection__new-product" />}
                {/* {<H3Text text="+ Add Product Info" className="pr-selection__new-product-info" />} */}
              </div>
              {
                !record?.remarkRequired
                && (
                  <QuickAddButton
                    label="Add Description"
                    onClick={(e) => this.updatePrLineValue(!record?.remarkRequired, record, 'remarkRequired')}
                  />
                )
              }
              {record?.remarkRequired ? (
                <ProductDescriptions
                  descriptions={record?.remark}
                  modules={{
                    toolbar: false,
                  }}
                  onChange={(str) => {
                    const strippedValue = str.replace(/<[^>]*>?/gm, '').trim();
                    if (strippedValue) {
                      this.updatePrLineValue(str, record, 'remark');
                    } else {
                      this.updatePrLineValue(false, record, 'remarkRequired');
                    }
                  }}
                  className="invoice-table__remarks"
                  placeholder="Add description of this item.."
                  key={record.key}
                />
              ) : ''}
            </div>
          );
        },
        visible: true,
        fixed: 'left',
      },
      {
        title: 'Issuer Location',
        width: '200px',
        render: (text, record) => {
          return (
            <TenantSelector
              hideTitle
              selectedTenant={record.tenantId}
              showSearch={false}
              onChange={(value) => {
                this.updatePrLineValue(value, record, 'tenantId');
              }}
              placeholder="Select Business Unit"
              labelClassName="form__input-row__label"
              includedTenants={Helpers.getTenantEntityPermission(user?.user_tenants, Helpers.permissionEntities.PURCHASE_REQUEST, Helpers.permissionTypes.CREATE)}
              disabled={userTenantDepartmentId !== tenantDefaultStoreId}
            />
          );
        },
        visible: true,
      },
      {
        title: 'Issuer Department',
        width: '200px',
        render: (record) => {
          return (
            <SelectDepartment
              hideTitle
              selectedDepartment={record.departmentId}
              onChange={(value) => {
                getProductById(record?.tenantId, record?.product_sku_info?.product_sku_id, value?.tenant_department_id, (product) => {
                  this.updatePrLineValue(
                    {
                      tenantDepartmentId: value?.tenant_department_id,
                      departmentName: value?.alias_name,
                      departmentId: value?.department_id,
                      departmentQuantities: product?.department_quantities,
                      tenantProductId: product?.tenant_product_id,
                    },
                    record,
                    null,
                    true,
                  );
                });
              }}
              tenantId={record.tenantId}
              labelClassName="form__input-row__label"
              emptyNotAllowed
              disabled={
                record.issuer_tenant_department_id
                  ? (record.issuer_tenant_id !== record.tenant_id && userTenantDepartmentId !== tenantDefaultStoreId)
                  : false
              }
            />
          );
        },
        visible: true,
      },
      {
        title: 'Unit',
        render: (record) => record?.uom_info?.uqc?.toProperCase() || '',
        visible: true,
      },
      {
        title: 'Quantity',
        render: (text, record) => {
          const { formSubmitted } = this.state;
          return (
            <H3FormInput
              value={record.quantity}
              type="number"
              containerClassName={`orgInputContainer ${(formSubmitted && !Number(record.quantity)) ? 'pr-selection__input-error' : ''}`}
              labelClassName="orgFormLabel"
              inputClassName="orgFormInput"
              onChange={(e) => this.updatePrLineValue(Number(e.target.value), record, 'quantity')}
              required
              noDecimal
            />
          );
        },
        visible: true,
      },
      {
        title: 'Available Qty',
        width: '200px',
        responsive: ['sm', 'md', 'lg', 'xxl'],
        render: (record) => {
          const {
            selectedPurchaseRequest,
          } = this.props;

          const { tenantDepartmentId, departmentQuantities } = record;

          const currentDepartmentStock = QUANTITY((departmentQuantities?.find((item) => item?.tenant_department_id === tenantDepartmentId)?.quantity) / record?.uom_info?.ratio, record?.uom_info?.precision);

          const filteredDepartmentsStock = departmentQuantities?.filter((item) => item?.tenant_department_id !== tenantDepartmentId);
          const totalStockInOtherDepartments = QUANTITY(filteredDepartmentsStock?.map((dept) => dept?.quantity).reduce((acc, cur) => acc + cur, 0) / record?.uom_info?.ratio, record?.uom_info?.precision);
          const totalPendingFromVendor = record?.pos_quantity_against_product?.map((quantity) => {
            const difference = quantity.total_pending_quantity - quantity.total_received_quantity;
            return difference;
          }).reduce((acc, cur) => acc + cur, 0);
          const hoverContentForPendingFromVendor = (
            <div>
              {record?.pos_quantity_against_product
                ?.filter((vendors) => vendors.total_pending_quantity - vendors.total_received_quantity > 0)
                ?.map((vendors) => (
                  <div
                    key={vendors.seller_id}
                    className="other-uom-stock"
                    onClick={() => {
                      window.open(`/purchase/purchase-orders?page=1&limit=10&tenant=${selectedPurchaseRequest?.tenant_id}&status=ISSUED&keyword=${vendors?.seller_name}&po_receiving_status=PARTIALLY_RECEIVED,NOT_RECEIVED&product_search_from_pr=${record?.product_sku_info?.product_sku_id}&product_prefill=true `);
                    }}
                    style={{
                      cursor: 'pointer',
                    }}
                  >
                    <Link target="_blank" className="ellipsis">
                      {`${vendors?.internal_slr_code} - ${vendors?.seller_name?.toProperCase()}`}
                    </Link>
                    <H3Text
                      text={`${QUANTITY(vendors?.total_pending_quantity - vendors?.total_received_quantity) || 0} ${record?.uom_info?.uqc?.toProperCase()}`}
                      className="tenant-inventory-slider__dept-qty"
                    />
                  </div>
                ))}
            </div>
          );
          const hoverContentForStock = (
            <div>
              {filteredDepartmentsStock?.map((dept) => (
                <div key={dept.department_id} className="other-uom-stock">
                  <H3Text text={dept?.alias_name} />
                  <H3Text
                    text={`${QUANTITY(dept?.quantity * (record?.product_sku_info?.uom_info?.ratio || 1) / (record?.uom_info?.ratio || 1) || 0, record?.product_sku_info?.uom_info?.precision)} ${record?.uom_info?.uqc?.toProperCase()}`}
                    className="tenant-inventory-slider__dept-qty"
                  />
                </div>
              ))}
            </div>
          );
          return (
            <Fragment>
              {`${currentDepartmentStock || 0} ${record?.uom_info?.uqc?.toProperCase() || ''}`}
              {totalStockInOtherDepartments > 0 && (
                <Popover
                  placement="bottom"
                  title="Stocks in other locations"
                  content={hoverContentForStock}
                  trigger="hover"
                >
                  <div
                    className="table-subscript"
                    style={{
                      color: 'rgb(109 107 106)',
                    }}
                  >
                    {`+${QUANTITY(totalStockInOtherDepartments, record?.uom_info?.precision)}  ${record?.uom_info?.uqc?.toProperCase() || ''} in other locations`}
                    <InfoCircleOutlined style={{
                      color: 'rgb(45, 124, 246)',
                      margin: '2px',
                    }}
                    />
                  </div>
                </Popover>
              )}
              {totalPendingFromVendor > 0 && (
                <Popover
                  placement="bottom"
                  title="Pending from vendors"
                  content={hoverContentForPendingFromVendor}
                  trigger="hover"
                >
                  <div
                    className="table-subscript"
                    style={{
                      color: 'rgb(109 107 106)',
                    }}
                  >
                    {`+${QUANTITY(totalPendingFromVendor, record?.uom_info?.precision)}  ${record?.uom_info?.uqc?.toProperCase() || ''} pending from vendors`}
                    <InfoCircleOutlined style={{
                      color: 'rgb(45, 124, 246)',
                      margin: '2px',
                    }}
                    />
                  </div>
                </Popover>
              )}
            </Fragment>
          );
        },
        visible: !this.props?.user?.tenant_info?.purchase_config?.sub_modules?.purchase_request?.settings?.stock_availability_visible,
        visible: true,
      },
      {
        title: 'Vendor',
        dataIndex: 'sku_offers',
        render: (item, record) => {
          const { formSubmitted } = this.state;
          const {
            getOffers, sellers, getSellers,
          } = this.props;
          return (
            <Fragment>
              {
                record?.tenant_product_id ? (
                  <Fragment>
                    {!record.sellerInfo?.seller_id ? (
                      <Button
                        style={{
                          fontSize: '12px',
                          borderColor: (formSubmitted && !record.sellerInfo) ? 'red' : 'default',
                          width: '200px',
                          textAlign: 'left',
                          paddingLeft: '10px',
                          height: '28px'
                        }}
                        onClick={() => {
                          this.setState({
                            selectOfferVisible: true,
                            currentLine: {
                              ...record,
                              tenantProductId: record?.tenantProductId,
                              productName: record?.product_sku_name,
                              productSkuId: record?.product_sku_info?.product_sku_id,
                            },
                          });
                          getOffers(record.tenantProductId, '');
                        }}
                      >
                        Select Vendor
                      </Button>
                    ) : (
                      <Button
                        style={{
                          fontSize: '12px',
                          width: '200px',
                          textAlign: 'left',
                          paddingLeft: '10px',
                        }}
                        onClick={() => {
                          this.setState({
                            selectOfferVisible: true,
                            currentLine: {
                              ...record,
                              tenantProductId: record?.tenant_product_id,
                              productName: record?.product_sku_name,
                              productSkuId: record?.product_sku_info?.product_sku_id,
                            },
                          });
                          getOffers(record.tenant_product_id, '');
                        }}
                      >
                        {record?.sellerInfo?.seller_name?.length > 25 ? `${record?.sellerInfo?.seller_name?.substr(0, 20)}...` : record?.sellerInfo?.seller_name}
                        <EditOutlined />
                      </Button>
                    )}
                  </Fragment>
                ) : (
                  <div className="pr-selection__vendor-dropdown">
                    {sellers && (
                      <PRZSelect
                        value={JSON.stringify(record?.seller)}
                        filterOption={false}
                        showSearch
                        placeholder="Select Vendor"
                        onChange={(selectedSeller) => {
                          const { selectedPurchaseRequest } = this.state;
                          const { taxesGroup, user } = this.props;
                          const isVendorOverseas = JSON.parse(selectedSeller)?.seller_info?.seller_type === 'OVERSEAS' && user?.tenant_info?.purchase_config?.sub_modules?.vendor?.settings?.hide_tax_for_overseas;
                          const selectedPr = JSON.parse(JSON.stringify(selectedPurchaseRequest));
                          const selectedPrLines = JSON.parse(JSON.stringify(selectedPr?.purchase_requistion_lines));
                          const updatedPrLines = selectedPrLines?.map((prLine) => {
                            if (prLine.pr_line_id === record?.pr_line_id) {
                              prLine.sellerId = JSON.parse(selectedSeller)?.seller_id;
                              prLine.tenantSellerId = JSON.parse(selectedSeller)?.tenant_seller_id;
                              prLine.seller = JSON.parse(selectedSeller);
                              prLine.sellerInfo = {
                                tenant_seller_id: JSON.parse(selectedSeller)?.tenant_seller_id,
                                ...JSON.parse(selectedSeller)?.seller_info,
                              };
                              prLine.tenantSellerInfo = {
                                tenant_seller_id: JSON.parse(selectedSeller)?.tenant_seller_id,
                                seller_id: JSON.parse(selectedSeller)?.seller_info?.seller_id,
                                seller_name: JSON.parse(selectedSeller)?.seller_info?.seller_name,
                                gst_number: JSON.parse(selectedSeller)?.seller_info?.gst_number,
                                email_id: JSON.parse(selectedSeller)?.seller_info?.mobile_id_1,
                                mobile: JSON.parse(selectedSeller)?.seller_info?.mobile_1,
                                seller_type: JSON.parse(selectedSeller)?.seller_info?.seller_type,
                              };
                              prLine.taxId = isVendorOverseas ? taxesGroup?.data?.find((tax) => tax?.tax_value === 0)?.tax_id : prLine?.product_sku_info?.tax_info?.tax_id;
                              prLine.tax_id = isVendorOverseas ? taxesGroup?.data?.find((tax) => tax?.tax_value === 0)?.tax_id : prLine?.product_sku_info?.tax_info?.tax_id;
                              prLine.taxValue = isVendorOverseas ? taxesGroup?.data?.find((tax) => tax?.tax_value === 0)?.tax_value : prLine?.product_sku_info?.tax_info?.tax_value;
                              prLine.tax_value = isVendorOverseas ? taxesGroup?.data?.find((tax) => tax?.tax_value === 0)?.tax_value : prLine?.product_sku_info?.tax_info?.tax_value;
                              prLine.taxInfo = isVendorOverseas ? taxesGroup?.data?.find((tax) => tax?.tax_value === 0) : prLine?.product_sku_info?.tax_info;
                            }
                            return prLine;
                          });
                          selectedPr.purchase_requistion_lines = updatedPrLines;
                          this.setState({
                            selectedPurchaseRequest: selectedPr,
                          });
                        }}
                        onSearch={(value) => {
                          getSellers(value, record.tenantId, 1, 10);
                        }}
                        getPopupContainer={(triggerNode) => triggerNode.parentNode}
                        style={{
                          border: `1px solid ${record?.sellerInfo ? 'none' : 'rgb(255,77,79)'}`,
                          borderRadius: '2px',
                          height: '28px',
                          fontSize: '13px',
                          width: '200px',
                        }}
                      >
                        {sellers && sellers?.sellers
                          ?.map((seller) => (
                            <Option
                              key={seller.seller_id}
                              value={JSON.stringify(seller)}
                            >
                              {seller?.seller_info?.seller_name}
                            </Option>
                          ))}
                      </PRZSelect>
                    )}
                  </div>
                )
              }
            </Fragment>
          );
        },
        visible: true,
      },
      {
        title: 'Tax',
        width: '140px',
        render: (item, record) => {
          const { formSubmitted } = this.state;
          return (
            <div style={{ width: '140px' }}>
              {record?.tenantSellerInfo?.seller_type !== 'OVERSEAS' ? (<SelectTax
                onChange={(value) => {
                  this.updatePrLineValue(value, record, 'tax');
                }}
                getPopupContainer={(triggerNode) => triggerNode.parentNode}
                selectedGST={record.tax_id}
                customStyle={{
                  border: (formSubmitted && !record.tax_id) ? ' 1px solid #ff4d4f' : 'none)',
                  borderRadius: '2px',
                  height: '28px',
                  width: '140px',
                  fontSize: '13px',
                }}
              />) : '-'}
            </div>
          );
        },
        visible: true,
      },
      {
        title: 'Unit Price',
        render: (text, record) => {
          const { formSubmitted } = this.state;
          return (
            <H3FormInput
              value={record.unitPrice}
              type="number"
              containerClassName={`orgInputContainer ${(formSubmitted && (((user?.tenant_info?.purchase_config?.sub_modules?.purchase_request?.settings?.purchase_request_target_price_required && !user?.tenant_info?.purchase_config?.sub_modules?.purchase_order?.settings?.enable_po_price_more_than_pr) ? Number(record.unitPrice) > Number(record.target_price) : false) || !Number(record.unitPrice))) ? 'pr-selection__input-error' : ''}`}
              labelClassName="orgFormLabel"
              inputClassName="orgFormInput"
              onChange={(e) => this.updatePrLineValue(e.target.value, record, 'unitPrice')}
              required
              hideInput={isDataMaskingPolicyEnable && isHideCostPrice}
              popOverMessage={"You don't have access to view unit price"}
            />
          );
        },
        visible: true,
      },
      {
        title: 'Target Price',
        render: (record) => {
          return (
            <div
              style={{
                color: (
                  user?.tenant_info?.purchase_config?.sub_modules?.purchase_request?.settings?.purchase_request_target_price_required
                  && !user?.tenant_info?.purchase_config?.sub_modules?.purchase_order?.settings?.enable_po_price_more_than_pr
                )
                  ? (Number(Number(record.target_price)?.toFixed(DEFAULT_CUR_ROUND_OFF))
                    < Number(Number(record.unitPrice)?.toFixed(DEFAULT_CUR_ROUND_OFF)) ? 'red' : 'black')
                  : 'black',
                fontWeight: '500',
              }}
            >
              {(isDataMaskingPolicyEnable && isHideCostPrice) ? <HideValue showPopOver popOverMessage={"You don't have access to view target price"} /> : this.props.MONEY(record.target_price || '0')}
            </div>
          );
        },
        visible: true,
        fixed: 'right'
      },
      {
        title: 'Total',
        render: (record) => ((isDataMaskingPolicyEnable && isHideCostPrice) ? <HideValue showPopOver popOverMessage={"You don't have access to view total"} /> : this.props.MONEY(this.getLineTotal(record) || '0')),
        visible: true,
        fixed: 'right'
      },
      {
        title: '',
        visible: true,
        render: (text, record) => (
          <Popconfirm
            placement="topRight"
            title="Are you sure exclude this item from purchase orders? You will not be able to add it back."
            onConfirm={() => this.handleDelete(record.pr_line_id)}
            okText="Yes"
            cancelText="No"
          >
            <div className="table__delete-button">
              <CloseOutlined />
            </div>
          </Popconfirm>

        ),
        fixed: 'right',
      },
    ];

    if (mergedArray?.length) {
      columns.splice(5, 0, ...CustomFieldHelpers.renderCustomLineColumns(false, mergedArray, updatedVisibleColumns, this.customLineInputChange, formSubmitted, '', '', '', '', '', '', '', true));
    }
    return columns.filter((item) => item.visible);
  }


  customLineInputChange(fieldValue, key) {
    const { selectedPurchaseRequest } = this.state;
    const copyData = JSON.parse(JSON.stringify(selectedPurchaseRequest?.purchase_requistion_lines));
    for (let i = 0; i < copyData.length; i++) {
      if (copyData[i]?.key === key) {
        copyData[i].lineCustomFields = fieldValue;
      }
    }
    this.setState({
      ...this.state,
      selectedPurchaseRequest: {
        ...selectedPurchaseRequest, purchase_requistion_lines: copyData,
      },
    })
  }

  customLineInputChangePO(fieldValue, key, item) {
    const copyData = JSON.parse(JSON.stringify(item));

    const updatedData = copyData.map(dataItem => {
      if (dataItem?.key === key) {
        return { ...dataItem, lineCustomFields: fieldValue };
      }
      return dataItem;
    });
    return updatedData;
  }

  customInputChangePO(fieldValue, cfId, documentCustomFields) {
    if (documentCustomFields) {
      let newCfPurchaseOrdersDoc = JSON.parse(JSON.stringify(documentCustomFields));
      const newCustomFields = newCfPurchaseOrdersDoc.map((customField) => {
        if (customField?.cfId === cfId) {
          if (customField?.fieldType === 'ATTACHMENT') {
            return {
              ...customField,
              fieldValue: fieldValue?.map((attachment) => ({
                url: attachment?.response?.response?.location || attachment?.url,
                type: attachment.type,
                name: attachment.name,
                uid: attachment.uid,
              })),
            };
          }
          return {
            ...customField,
            fieldValue: fieldValue,
          };
        }
        return {
          ...customField,
        };
      });
      return newCustomFields;
    }
  }

  customInputChange(fieldValue, cfId) {
    const { cfPurchaseOrdersDoc } = this.state;
    const newCustomField = cfPurchaseOrdersDoc.map((customField) => {
      if (customField?.cfId === cfId) {
        if (customField?.fieldType === 'ATTACHMENT') {
          return {
            ...customField,
            fieldValue: fieldValue?.map((attachment) => ({
              url: attachment?.response?.response?.location || attachment?.url,
              type: attachment.type,
              name: attachment.name,
              uid: attachment.uid,
            })),
          };
        }
        return {
          ...customField,
          fieldValue,
        };
      }
      return {
        ...customField,
      };
    });
    this.setState({
      cfPurchaseOrdersDoc: newCustomField,
    });
  }

  componentDidMount() {
    const { getSellers, user, getDocCFV2, getTaxes } = this.props;
    const { visibleColumns } = this.state;
    const payloadPR = {
      orgId: user?.tenant_info?.org_id,
      entityName: 'PURCHASE_REQUEST',
    };
    const payloadPO = {
      orgId: user?.tenant_info?.org_id,
      entityName: 'PURCHASE_ORDERS',
    };
    getTaxes(user?.tenant_info?.org_id, 1, 1000, null, true);
    getSellers('', user?.tenant_info?.tenant_id, 1, 10);
    getDocCFV2(payloadPR, (cfData) => {
      const lineCFs = CustomFieldHelpers.getCfStructure(cfData?.data?.document_line_custom_fields?.filter((item) => item?.is_active), false);
      this.setState({
        cfPurchaseRequestLine: lineCFs,
        cfPurchaseRequestDoc: CustomFieldHelpers.getCfStructure(cfData?.data?.document_custom_fields),
        visibleColumns: CustomFieldHelpers.updateVisibleColumns(cfData?.data?.document_line_custom_fields, visibleColumns),
      })
    });
    getDocCFV2(payloadPO, (cfData) => {
      const lineCFs = CustomFieldHelpers.getCfStructure(cfData?.data?.document_line_custom_fields?.filter((item) => item?.is_active), false);
      this.setState({
        cfPurchaseOrderLine: lineCFs,
        cfPurchaseOrdersDoc: CustomFieldHelpers.getCfStructure(cfData?.data?.document_custom_fields),
      })
    });
  }

  /**
   *
   * @param props
   * @param state
   * @return {{isUserReady}|*|(*&{isUserReady: boolean})}
   */
  static getDerivedStateFromProps(props, state) {
    const { user, match, getPurchaseRequestById, getDocSequence, taxesGroup } = props;
    if (user?.tenant_info?.tenant_id && !state.isUserReady && !props.selectedRows?.length && taxesGroup?.success) {
      getPurchaseRequestById(match?.params?.prId, Helpers.getTenantEntityPermission(user?.user_tenants, Helpers.permissionEntities.PURCHASE_REQUEST, Helpers.permissionTypes.READ).join(','), () => {
      });
      return {
        ...state,
        isUserReady: true,
      };
    }
    if (props.selectedRows?.length && !state.isUserReadyForPRs) {
      const prLines = [];
      props.selectedRows?.map((selectedPurchaseRequest) => {
        let tempPrLines = selectedPurchaseRequest?.purchase_requistion_lines;
        tempPrLines = tempPrLines.map((item) => ({
          ...item, tax_id: item.tax_id ? item.tax_id : item?.product_sku_info?.tax_id, tax_value: item?.product_sku_info?.tax_info?.tax_value, tax_name: item?.product_sku_info?.tax_info?.tax_name, uom_info: item?.uom_info, taxInfo: item?.product_sku_info?.tax_info,
          remarkRequired: !!item?.remark?.trim()?.replace(/<[^>]+>/g, ''),
        }));
        prLines.push(...tempPrLines);
      });
      return {
        ...state,
        selectedPurchaseRequest: {
          purchase_requistion_lines: prLines,
        },
        isUserReadyForPRs: true,

      };
    }
    if (((props.selectedPurchaseRequest && !state.selectedPurchaseRequest) || (props.selectedPurchaseRequest && state.selectedPurchaseRequest && props.selectedPurchaseRequest?.purchase_requisition_id !== state.selectedPurchaseRequest?.purchase_requisition_id)) && props.cfV2DocPurchaseOrders?.data.success) {
      const tempSelectedPr = props.selectedPurchaseRequest;
      // getDocSequence({
      //   query: {
      //     tenant_id: tempSelectedPr?.issuer_tenant_id ? tempSelectedPr?.issuer_tenant_id : tempSelectedPr?.tenant_id,
      //     entity_name: 'PURCHASE_ORDER',
      //   },
      // });
      const docCFsFromPR = tempSelectedPr?.custom_fields;
      const mergedDocCfs = CustomFieldHelpers.postCfStructure(state.cfPurchaseOrdersDoc).map((orderDoc) => {
        const oldField = docCFsFromPR?.find((old) => old.cf_id === orderDoc.cf_id);
        return { ...orderDoc, field_value: oldField?.field_value || orderDoc?.field_value, is_editable_on_update: orderDoc?.isEditable, is_editable_while_carrying_forward: orderDoc?.isCarryForward, };
      });

      const caseConvertedCFs = CustomFieldHelpers.getCfStructure(mergedDocCfs);
      let tempPrLines = props?.selectedPurchaseRequest?.purchase_requistion_lines;
      // tempPrLines = tempPrLines.map((item) => ({
      //   ...item, tax_id: item.tax_id ? item.tax_id : item?.product_sku_info?.tax_id, tax_value: item?.product_sku_info?.tax_info?.tax_value, tax_name: item?.product_sku_info?.tax_info?.tax_name, uom_info: item?.uom_info, taxInfo: item?.product_sku_info?.tax_info,
      //   remarkRequired: !!item?.remark?.trim()?.replace(/<[^>]+>/g, ''),
      //   productCategoryInfo: item?.product_sku_info?.product_category_info,
      //   // lineCustomFields: CustomFieldHelpers.getCfStructure(item?.custom_fields) ?? [],
      //   lineCustomFields: mapCustomFields(item, state.cfPurchaseOrderLine) ?? [],
      //   key: uuidv4(),
      // }));
      const updatedPrLines = [];
      for (let i = 0; i < tempPrLines.length; i++) {
        const item = tempPrLines[i];
        const mergedLineCFs = state.cfPurchaseOrderLine.map((orderLine) => {
          const requestLine = CustomFieldHelpers.getCfStructure(item?.custom_fields)?.find(
            (request) => request.cfId === orderLine.cfId
          );
          return requestLine ? { ...orderLine, fieldValue: requestLine?.fieldValue || orderLine?.fieldValue } : orderLine;
        });
        updatedPrLines.push({
          ...item,
          tenantId: item.tenantId || tempSelectedPr?.issuer_tenant_id ? tempSelectedPr?.issuer_tenant_id : tempSelectedPr?.tenant_id,
          departmentId: item.departmentId || tempSelectedPr?.issuer_department_info?.department_id ? tempSelectedPr?.issuer_department_info?.department_id : tempSelectedPr?.department_id,
          tenantDepartmentId: item.tenantDepartmentId || tempSelectedPr?.issuer_tenant_department_id ? tempSelectedPr?.issuer_tenant_department_id : tempSelectedPr?.tenant_department_id,
          departmentName: item.departmentName || tempSelectedPr?.issuer_department_info?.department_name ? tempSelectedPr?.issuer_department_info?.department_name : tempSelectedPr?.tenant_department_alias_name,
          departmentQuantities: item.departmentQuantities || item.department_quantities,
          tenantProductId: item?.tenantProductId || item?.tenant_product_id,
          tax_id: item.tax_id || item?.product_sku_info?.tax_id,
          tax_value: item?.product_sku_info?.tax_info?.tax_value,
          tax_name: item?.product_sku_info?.tax_info?.tax_name,
          uom_info: item?.uom_info,
          taxInfo: item?.product_sku_info?.tax_info,
          remarkRequired: !!item?.remark?.trim()?.replace(/<[^>]+>/g, ''),
          productCategoryInfo: item?.product_sku_info?.product_category_info,
          lineCustomFields: mergedLineCFs ?? [],
          key: uuidv4(),
        });
      }
      tempPrLines = updatedPrLines;
      return {
        ...state,
        cfPurchaseOrdersDoc: caseConvertedCFs,
        selectedPurchaseRequest: {
          ...tempSelectedPr, purchase_requistion_lines: tempPrLines,
        },
      };
    }
    return state;
  }

  /**
   * @param {*} value
   * @param record
   * @param label
   */
  // eslint-disable-next-line react/sort-comp
  updatePrLineValue = (value, record, label, isMultipleUpdate = false) => {
    const { user } = this.props;
    const { selectedPurchaseRequest } = this.state;
    const selectedPr = JSON.parse(JSON.stringify(selectedPurchaseRequest));
    const selectedPrLines = JSON.parse(JSON.stringify(selectedPr?.purchase_requistion_lines));
    const taxableValue = record?.quantity * record.price;
    const updatedPrLines = selectedPrLines?.map((prLine) => {
      if (prLine.pr_line_id === record.pr_line_id) {
        if (isMultipleUpdate && typeof value === 'object' && !Array.isArray(value)) {
          Object.entries(value).forEach(([key, val]) => {
            prLine[key] = val;
          });
        } else if (label === 'tax') {
          prLine.tax_id = value?.tax_id;
          prLine.tax_name = value.tax_name;
          prLine.tax_value = value?.tax_value;
          prLine.taxInfo = value;
          prLine.child_taxes = Helpers.computeTaxation(taxableValue, value, user?.user_tenants?.find((tenant) => tenant?.tenant_id === record.tenantId)?.default_billing_address_info?.state, record?.sellerInfo?.state)?.tax_info?.child_taxes;
        } else {
          prLine[label] = value;
          if (label === 'tenantId') {
            // Clear seller-related fields
            prLine.sellerId = null;
            prLine.tenantSellerId = null;
            prLine.seller = null;
            prLine.sellerInfo = null;
            prLine.tenantSellerInfo = null;
            // Clear department-related fields
            prLine.departmentId = null;
            prLine.departmentName = null;
            prLine.tenantDepartmentId = null;
            prLine.departmentQuantities = null;
          }
          prLine.child_taxes = Helpers.computeTaxation(taxableValue, record?.tax_info, user?.user_tenants?.find((tenant) => tenant?.tenant_id === prLine.tenantId)?.default_billing_address_info?.state, record?.sellerInfo?.state)?.tax_info?.child_taxes;
        }
      }
      return prLine;
    });
    selectedPr.purchase_requistion_lines = updatedPrLines;
    this.setState({
      selectedPurchaseRequest: selectedPr,
    });
  }

  /**
   * @param {*} value
   * @param record
   * @param key
   * @param label
   */
  handleDelete = (key) => {
    const { selectedPurchaseRequest } = this.state;
    const selectedPr = JSON.parse(JSON.stringify(selectedPurchaseRequest));
    const selectedPrLines = JSON.parse(JSON.stringify(selectedPr?.purchase_requistion_lines));
    const filteredSelectedPrLines = JSON.parse(JSON.stringify(selectedPrLines))?.filter((item) => (item.pr_line_id !== key));
    selectedPr.purchase_requistion_lines = filteredSelectedPrLines;
    this.setState({ selectedPurchaseRequest: selectedPr });
  }

  /**
   * @param {*} requestId
   * @param seller
   * @param record
   * @param lineId
   * @param {*} offerP
   */
  handleSellerSelection = (lineId, record, selectedSoIds, selectedMoIds, currentLine) => {
    const { selectedPurchaseRequest } = this.state;
    const { taxesGroup, user } = this.props;
    const selectedPr = JSON.parse(JSON.stringify(selectedPurchaseRequest));
    const selectedPrLines = JSON.parse(JSON.stringify(selectedPr?.purchase_requistion_lines));

    const isVendorOverseas = record?.seller_info?.seller_type === 'OVERSEAS' && user?.tenant_info?.purchase_config?.sub_modules?.vendor?.settings?.hide_tax_for_overseas;
    const updatedPrLines = selectedPrLines?.map((prLine) => {
      // if (prLine.tenant_product_id === lineId) {
      if (prLine.pr_line_id === currentLine?.pr_line_id) {
        prLine.seller_id = record?.seller_info?.seller_id;
        prLine.tenantSellerId = record?.tenant_seller_id;
        prLine.tenantSellerInfo = {
          tenant_seller_id: record?.tenant_seller_id,
          seller_id: record?.seller_info?.seller_id,
          seller_name: record?.seller_info?.seller_name,
          gst_number: record?.seller_info?.gst_number,
          email_id: record?.seller_info?.mobile_id_1,
          mobile: record?.seller_info?.mobile_1,
          seller_type: record?.seller_info?.seller_type,
        };
        prLine.unitPrice = record?.offer_price;
        prLine.productSkuId = record?.product_info?.product_sku_id;
        prLine.tenantProductId = record?.tenant_product_id;
        prLine.skuOfferId = record?.sku_offer_id;
        prLine.quantity = Number(prLine?.quantity) || (record?.quantity || record?.moq);
        prLine.sellerMoq = record?.moq;
        prLine.sellerInfo = {
          ...record?.seller_info,
          tenant_seller_id: record?.tenant_seller_id,
          default_payment_terms: record?.seller_info?.default_payment_terms,
        };
        prLine.taxId = isVendorOverseas ? taxesGroup?.data?.find((tax) => tax?.tax_value === 0)?.tax_id : prLine?.product_sku_info?.tax_info?.tax_id;
        prLine.tax_id = isVendorOverseas ? taxesGroup?.data?.find((tax) => tax?.tax_value === 0)?.tax_id : prLine?.product_sku_info?.tax_info?.tax_id;
        prLine.taxValue = isVendorOverseas ? taxesGroup?.data?.find((tax) => tax?.tax_value === 0)?.tax_value : prLine?.product_sku_info?.tax_info?.tax_value;
        prLine.tax_value = isVendorOverseas ? taxesGroup?.data?.find((tax) => tax?.tax_value === 0)?.tax_value : prLine?.product_sku_info?.tax_info?.tax_value;
        prLine.taxInfo = isVendorOverseas ? taxesGroup?.data?.find((tax) => tax?.tax_value === 0) : prLine?.product_sku_info?.tax_info;
        prLine.child_taxes = Helpers.computeTaxation((prLine?.quantity * prLine?.unitPrice), isVendorOverseas ? taxesGroup?.data?.find((tax) => tax?.tax_value === 0) : prLine?.product_sku_info?.tax_info, user?.user_tenants?.find((tenant) => tenant?.tenant_id === prLine.tenantId)?.default_billing_address_info?.state, record?.sellerInfo?.state)?.tax_info?.child_taxes;
      }
      return prLine;
    });
    selectedPr.purchase_requistion_lines = updatedPrLines;
    this.setState({
      selectedPurchaseRequest: selectedPr,
    });
  }

  /**
   *
   * @return
   */
  getTotal() {
    const { selectedPurchaseRequest } = this.state;
    let total = 0;
    let length = 0;
    if (selectedPurchaseRequest) {
      const selectedPr = JSON.parse(JSON.stringify(selectedPurchaseRequest));
      const selectedPrLines = JSON.parse(JSON.stringify(selectedPr?.purchase_requistion_lines));
      selectedPrLines?.map((item) => {
        total += (Number(item?.unitPrice || 0) * Number(item?.quantity || 0) * (1 + item?.tax_value / 100));
      });
      length = selectedPrLines?.length;
    }
    return {
      total,
      length,
    };
  }

  /**
   * @return
   * @param record
   */
  getLineTotal(record) {
    const { user } = this.props;

    let total = 0;
    if (record.quantity && record.unitPrice && record?.taxInfo) {
      const taxableValue = record.quantity * record.unitPrice;
      total = Helpers.computeTaxation(taxableValue, record.taxInfo, user?.user_tenants?.find((tenant) => tenant?.tenant_id === record.tenantId)?.default_billing_address_info?.state, record?.sellerInfo?.state)?.taxed_value;
    }
    return total;
  }

  /**
   *
   *
   */
  convertToPo() {
    const { selectedPurchaseRequest, cfPurchaseOrderLine, cfPurchaseOrdersDoc } = this.state;
    const { user, documentSequence } = this.props;
    const selectedPr = JSON.parse(JSON.stringify(selectedPurchaseRequest));
    const selectedPrLines = JSON.parse(JSON.stringify(selectedPr?.purchase_requistion_lines));
    const tenantSellerPRItems = {};
    for (let i = 0; i < selectedPrLines?.length; i++) {
      const prLine = selectedPrLines?.[i];
      const mergedCfLines = cfPurchaseOrderLine.map((orderLine) => {
        const requestLine = prLine?.lineCustomFields?.find((request) => request.cfId === orderLine.cfId);
        return requestLine ? { ...orderLine, fieldValue: requestLine?.fieldValue || orderLine?.fieldValue } : orderLine;
      });
      if (tenantSellerPRItems.hasOwnProperty(`${prLine?.tenantDepartmentId}-${prLine?.tenantSellerId}`)) {
        tenantSellerPRItems[`${prLine?.tenantDepartmentId}-${prLine?.tenantSellerId}`].push(prLine);
      } else {
        const defaultExpiryDays = user?.tenant_info?.purchase_config?.sub_modules?.purchase_order?.settings?.default_expiry_days;
        tenantSellerPRItems[`${prLine?.tenantDepartmentId}-${prLine?.tenantSellerId}`] = [{
          ...prLine,
          po_date: dayjs(),
          delivery_date: dayjs(),
          expiry_date: defaultExpiryDays ? dayjs().add(defaultExpiryDays, 'day') : dayjs(),
          payment_terms: prLine?.sellerInfo?.default_payment_terms?.due_days,
          gst_number: prLine?.sellerInfo?.gst_number,
          email_id: prLine?.sellerInfo?.email_id_1 ? [prLine?.sellerInfo?.email_id_1] : [],
          checkedRecipients: true,
          sendWhatsappNotification: false,
          lineCustomFields: mergedCfLines,
          documentCustomFields: cfPurchaseOrdersDoc,
          poNumber: '',
          docSeqId: null,
          initialPoNumber: '',
          showAddressDrawer: false,
          vendorAddress: prLine?.sellerInfo?.office_address_details,
          billingAddress: user?.user_tenants?.find((tenant) => tenant?.tenant_id === prLine?.tenantId)?.default_billing_address_info,
          selectedAddressType: "",
        }];
      }
    }
    if (this.isDataValid()) {
      this.setState({ showPurchaseConfirmation: true, tenantSellerPRItems });
    }
  }

  /**
 *
 * @param tenantSellerId
 * @param key
 * @param value
 */
  updateSellerInfo(tenantSellerId, label, value, key, cfId, tenantDepartmentId) {
    const { tenantSellerPRItems } = this.state;
    let prItemsCopy;
    prItemsCopy = JSON.parse(JSON.stringify(tenantSellerPRItems));
    if (label === 'lineCustomFields') {
      prItemsCopy[`${tenantDepartmentId}-${tenantSellerId}`] = this.customLineInputChangePO(value, key, tenantSellerPRItems[`${tenantDepartmentId}-${tenantSellerId}`]);
    } else if (label === 'documentCustomFields') {
      prItemsCopy[`${tenantDepartmentId}-${tenantSellerId}`].map(dataItem => {
        dataItem.documentCustomFields = this.customInputChangePO(value, cfId, dataItem?.documentCustomFields);
      })
    } else if (label === 'poNumber') {
      prItemsCopy[`${tenantDepartmentId}-${tenantSellerId}`][0][label] = value?.poNumber;
      prItemsCopy[`${tenantDepartmentId}-${tenantSellerId}`][0]['docSeqId'] = value?.seqId;
    } else if (label === 'vendorAddress' || label === 'billingAddress') {
      prItemsCopy[`${tenantDepartmentId}-${tenantSellerId}`][0][label] = value;
      prItemsCopy[`${tenantDepartmentId}-${tenantSellerId}`][0]['showAddressDrawer'] = false;
    } else if (label === 'selectedAddressType') {
      prItemsCopy[`${tenantDepartmentId}-${tenantSellerId}`][0][label] = value;
      prItemsCopy[`${tenantDepartmentId}-${tenantSellerId}`][0]['showAddressDrawer'] = true;
    }
    else {
      prItemsCopy[`${tenantDepartmentId}-${tenantSellerId}`][0][label] = value;
    }
    this.setState({ tenantSellerPRItems: prItemsCopy });
  }

  /**
   *
   * @return {boolean}
   */
  isDataValid() {
    const { selectedPurchaseRequest, showErrorMessage, cfPurchaseOrdersDoc } = this.state;
    const { user } = this.props;
    let isDataValid = true;
    let shouldShowErrorMessage = false;

    if (selectedPurchaseRequest) {
      const selectedPr = JSON.parse(JSON.stringify(selectedPurchaseRequest));
      const selectedPrLines = JSON.parse(JSON.stringify(selectedPr?.purchase_requistion_lines));

      if (cfPurchaseOrdersDoc?.length > 0) {
        cfPurchaseOrdersDoc?.map((fields) => {
          if (fields?.isActive && fields?.isRequired && !fields?.fieldValue) {
            isDataValid = false;
            return isDataValid;
          }
        });
      }

      for (let i = 0; i < selectedPrLines?.length; i++) {
        const prLine = selectedPrLines[i];

        if (((!user?.tenant_info?.purchase_config?.sub_modules?.purchase_order?.settings?.enable_po_price_more_than_pr && user?.tenant_info?.purchase_config?.sub_modules?.purchase_request?.settings?.purchase_request_target_price_required)
          ? Number(Number(prLine?.unitPrice || 0)?.toFixed(DEFAULT_CUR_ROUND_OFF)) > Number(Number(prLine?.target_price || 0)?.toFixed(DEFAULT_CUR_ROUND_OFF))
          : false)) {
          shouldShowErrorMessage = true; // Set the flag to true if any condition fails
        }


        if (
          prLine?.quantity <= 0
          || !prLine?.sellerInfo
          || !prLine?.tax_id
          || !prLine?.unitPrice
          || !prLine?.product_sku_name
          || !prLine?.tenantDepartmentId
          || (user?.tenant_info?.purchase_config?.sub_modules?.purchase_request?.settings?.purchase_request_target_price_required && !user?.tenant_info?.purchase_config?.sub_modules?.purchase_order?.settings?.enable_po_price_more_than_pr
            ? Number(Number(prLine?.unitPrice || 0)?.toFixed(DEFAULT_CUR_ROUND_OFF)) > Number(Number(prLine?.target_price || 0)?.toFixed(DEFAULT_CUR_ROUND_OFF))
            : false)
        ) {
          isDataValid = false;
          break;
        }
        if (prLine?.lineCustomFields?.length > 0) {
          prLine?.lineCustomFields?.filter((field) => field?.fieldName !== "Quantity" && field?.fieldName !== "Rate")?.map((fields) => {
            if (fields?.isActive && fields?.isRequired && !fields?.fieldValue) {
              isDataValid = false;
              return isDataValid;
            }
          });
          if (!isDataValid) {
            break;
          }
        }
      }

      if (shouldShowErrorMessage && !showErrorMessage) {
        this.setState({
          showErrorMessage: true,
        });
      } else if (!shouldShowErrorMessage && showErrorMessage) {
        this.setState({
          showErrorMessage: false,
        });
      }
    }

    return isDataValid;
  }

  isDataValidPO() {
    const { tenantSellerPRItems } = this.state;
    const copyTenantSellerPRItems = JSON.parse(JSON.stringify(Object.values(tenantSellerPRItems)));
    for (const subArray of copyTenantSellerPRItems) {
      if (subArray[0]?.documentCustomFields?.length > 0) {
        for (const field of subArray[0]?.documentCustomFields) {
          if (field?.isRequired && !field?.fieldValue && field?.isActive) {
            return false;
          }
        }
      }
      if (subArray[0]?.lineCustomFields?.length > 0) {
        for (const field of subArray[0]?.lineCustomFields) {
          if (field?.isRequired && !field?.fieldValue && field?.fieldName !== "Rate" && field?.fieldName !== "Quantity" && field?.isActive) {
            return false;
          }
        }
      }
    }
    return true;
  }

  getDataSource(data) {
    const copyData = structuredClone(data);
    const sortedData = Helpers.sortByParameter({
      data: copyData,
      parameter: 'product_sku_info.internal_sku_code',
    });

    return sortedData;
  }

  // getDataSource(data) {
  //   return JSON.parse(JSON.stringify(data));
  // }

  render() {
    const {
      getPurchaseRequestByIdLoading, sellers, MONEY, getTaxesLoading,
    } = this.props;
    const {
      columns, selectOfferVisible, currentLine, selectedPurchaseRequest, showPurchaseConfirmation, tenantSellerPRItems, showErrorMessage, visibleColumns, cfPurchaseRequestLine, cfPurchaseOrderLine, cfPurchaseOrdersDoc,
    } = this.state;
    const userMenuConfig = JSON.parse(localStorage.getItem('user_menu_config'));

    return (
      <div className='pr-selection__preview-container'>
        {getPurchaseRequestByIdLoading
          ? (
            <div className={`${window.location.href.includes('/purchase/purchase-request/vendor-selection/') ? 'pr-selection__preview-page pr-selection__loading__wrapper' : 'pr-selection__loading__wrapper'}`}>
              {[1, 2, 3, 4, 5].map((item) => (
                <div key={item} className="pr-selection__loading__wrapper-row">
                  <div className="pr-selection__loading__wrapper-row__label loadingBlock" />
                  <div className="pr-selection__loading__wrapper-row__value loadingBlock" />
                </div>
              ))}
              <div className="pr-selection__loading__wrapper-table loadingBlock" />
            </div>
          ) : (
            // <div className={`${window.location.href.includes('/purchase/purchase-request/vendor-selection/') ? ' pr-selection__preview-page' : ''} pr-selection__preview-container `}>
            <div className='form__wrapper'>
              <div className="ant-row">
                <div className="ant-col-md-24">
                  <div className="form__section">
                    <div className="form__section-inputs mg-bottom-20">
                      <div className="ant-row">
                        <div className="ant-col-md-6">
                          <div className='form__input-row'>
                            <H3Text text="Request#" className="form__input-row__label" />
                            <H3Text text={`${selectedPurchaseRequest?.pr_number ? selectedPurchaseRequest.pr_number : '-'}`} className="form__input-row__input" style={{ alignContent: 'center' }} />
                          </div>
                        </div>
                        <div className="ant-col-md-6">
                          <div className='form__input-row'>
                            <H3Text text="Requestor" className="form__input-row__label" />
                            <H3Text text={`${selectedPurchaseRequest?.created_by_info?.first_name} on ${dayjs(selectedPurchaseRequest?.created_at).format('DD/MM/YYYY')}`} className="form__input-row__input" style={{ alignContent: 'center' }} />
                          </div>
                        </div>
                        <div className="ant-col-md-6">
                          <div className='form__input-row'>
                            <H3Text text="Request Date" className="form__input-row__label" />
                            <H3Text
                              text={selectedPurchaseRequest?.pr_date ? (toISTDate(selectedPurchaseRequest.pr_date).format('DD/MM/YYYY')) : '-'}
                              className="form__input-row__input" style={{ alignContent: 'center' }}
                            />
                          </div>
                        </div>
                        <div className="ant-col-md-6">
                          <div className='form__input-row'>
                            <H3Text text="Delivery Date" className="form__input-row__label" />
                            <H3Text
                              text={selectedPurchaseRequest?.delivery_date ? (toISTDate(selectedPurchaseRequest.delivery_date).format('DD/MM/YYYY')) : '-'}
                              className="form__input-row__input" style={{ alignContent: 'center' }}
                            />
                          </div>
                        </div>
                        <div className="ant-col-md-6">
                          <div className='form__input-row'>
                            <H3Text text="Additional Remarks" className="form__input-row__label" />
                            <H3Text
                              text={selectedPurchaseRequest?.remark ? selectedPurchaseRequest?.remark : '--'}
                              className="form__input-row__input" style={{ alignContent: 'center' }}
                            />
                          </div>
                        </div>
                        <CustomFieldV3
                          customFields={cfPurchaseOrdersDoc}
                          formSubmitted={true}
                          customInputChange={(value, cfId) => this.customInputChange(value, cfId)}
                          wrapperClassName="ant-col-md-6"
                          containerClassName="form__input-row"
                          labelClassName="form__input-row__label"
                          inputClassName="form__input-row__input"
                          errorClassName="form__input-row__input-error"
                          disableCase={false}
                          hideTitle
                          isCarryForward={true}
                        />
                        {(showErrorMessage) && (
                          <Alert
                            className="vq__unit-price-alert"
                            message={(
                              <div>
                                <span>
                                  <StopOutlined
                                    style={{
                                      color: '#ff4d4f',
                                      marginRight: '5px',
                                    }}
                                  />
                                </span>
                                Unit Price cannot exceeds Target Price. Please set the unit price which is less than or equal to the target price.
                              </div>
                            )}
                            type="warning"
                          />
                        )}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <SelectOffer
                selectOfferVisible={selectOfferVisible}
                toggleOfferModal={() => this.setState({ selectOfferVisible: !selectOfferVisible })}
                currentLine={currentLine}
                handleSellerSelection={this.handleSellerSelection}
                type="order"
                tenantId={currentLine?.tenantId}
              />
              {sellers && selectedPurchaseRequest && (
                <div style={{ marginBottom: '80px' }}>
                  <Table
                    title={() => (
                      <div className='pr-selection__title__wrapper'>
                        <div className="pr-selection__title__header">
                          <div className="pr-selection__title__header-icon">
                            <ShoppingFilled />
                          </div>
                          {selectedPurchaseRequest?.purchase_requistion_lines?.length || 0}
                          {' '}
                          Items in this Material Request
                        </div>
                      </div>
                    )}
                    loading={getPurchaseRequestByIdLoading || getTaxesLoading}
                    // columns={columns}
                    columns={this.getColumns()}
                    size="small"
                    dataSource={this.getDataSource(selectedPurchaseRequest?.purchase_requistion_lines)}
                    pagination={false}
                    scroll={{ x: 'max-content' }}
                  />
                </div>
              )}
              <div
                className={`form__footer ${userMenuConfig === "FIXED" ? 'form__footer-fixed' : ''} pr-selection__footer-containers `}
                style={{
                  zIndex: '2',
                }}
              >
                <div className="pr-selection__footer-left">
                  {MONEY(this.getTotal().total)}
                  <span style={{ color: 'black', fontWeight: '400', marginLeft: '10px' }}>
                    {`(${selectedPurchaseRequest?.purchase_requistion_lines?.length || 0} Items in this Material Request)`}
                  </span>
                </div>
                <div className="po-selection__footer-right">
                  <Button
                    type="primary"
                    onClick={() => {
                      this.convertToPo();
                    }}
                    disabled={!this.isDataValid()}
                  >
                    Verify Purchase Orders
                  </Button>
                </div>
              </div>
              <Drawer
                open={showPurchaseConfirmation}
                width="900px"
                mask
                onClose={() => this.setState({ showPurchaseConfirmation: false })}
                destroyOnClose
              >
                <div className="custom-drawer__header-wrapper">
                  <div className="custom-drawer__header" style={{ width: '850px' }}>
                    <H3Text text={`Confirm Purchase Orders ${`#${selectedPurchaseRequest?.purchase_requisition_id}`}`} className="custom-drawer__title" />
                    <H3Image src={closeIcon} className="custom-drawer__close-icon" onClick={() => this.setState({ showPurchaseConfirmation: false })} />
                  </div>
                </div>
                <PRVerifyPurchaseOrders
                  selectedPurchaseRequest={selectedPurchaseRequest}
                  tenantSellerPRItems={tenantSellerPRItems}
                  updateSellerInfo={(tenantSellerId, label, value, key, cfId, tenantDepartmentId) => this.updateSellerInfo(tenantSellerId, label, value, key, cfId, tenantDepartmentId)}
                  cfPurchaseRequestLine={cfPurchaseRequestLine}
                  cfPurchaseOrderLine={cfPurchaseOrderLine}
                  visibleColumns={visibleColumns}
                  customLineInputChange={this.customLineInputChange}
                  isDataValidPO={this.isDataValidPO}
                  isCarryForward={true}
                />
              </Drawer>
            </div>
          )}
      </div>
    );
  }
}
const mapStateToProps = ({
  UserReducers, PurchaseRequestReducers, SellerReducers, CFV2Reducers, PurchaseOrderReducers, GetDocSequence, TaxReducers,
}) => ({
  user: UserReducers.user,
  MONEY: UserReducers.MONEY,
  selectedPurchaseRequest: PurchaseRequestReducers.selectedPurchaseRequest,
  getPurchaseRequestByIdLoading: PurchaseRequestReducers.getPurchaseRequestByIdLoading,
  sellers: SellerReducers.sellers,
  priceMasking: UserReducers.priceMasking,
  getDocCFV2Loading: CFV2Reducers.getDocCFV2Loading,
  cfV2DocPurchaseRequest: CFV2Reducers.cfV2DocPurchaseRequest,
  cfV2DocPurchaseOrders: CFV2Reducers.cfV2DocPurchaseOrders,
  getPurchaseOrderByIdLoading:
    PurchaseOrderReducers.getPurchaseOrderByIdLoading,
  taxesGroup: TaxReducers.taxesGroup,
  getTaxesLoading: TaxReducers.getTaxesLoading,
});

const mapDispatchToProps = (dispatch) => ({
  getPurchaseRequestById: (prId, tenantId, callback) => dispatch(PurchaseRequestActions.getPurchaseRequestById(prId, tenantId, callback)),
  getOffers: (tenantProductId, tenantSellerId) => dispatch(OfferActions.getOffers(tenantProductId, tenantSellerId)),
  getSellers: (keyword, tenantId, page, limit, sellerId, callback) => dispatch(SellerActions.getSellers(keyword, tenantId, page, limit, sellerId, callback)),
  getDocCFV2: (payload, callback) => dispatch(CFV2Actions.getDocCFV2(payload, callback)),
  getProductById: (tenantId, productSkuId, tenantDepartmentId, callback) => dispatch(ProductActions.getProductById(tenantId, productSkuId, tenantDepartmentId, callback)),
  getDocSequence: (payload, callback) => dispatch(GetDocSequence.actions.request(payload, callback)),
  getTaxes: (orgId, page, limit, isActive, isGroup) => dispatch(TaxActions.getTaxes(orgId, page, limit, isActive, isGroup)),
});

PRSellerSelection.propTypes = {
  getOffers: PropTypes.func,
  user: PropTypes.any,
  selectedPurchaseRequest: PropTypes.any,
  getPurchaseRequestByIdLoading: PropTypes.bool,
  selectedRows: PropTypes.any,
  getSellers: PropTypes.func,
  sellers: PropTypes.any,
  getPurchaseRequestById: PropTypes.func,
  match: PropTypes.any,
};

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(PRSellerSelection));
